import { indexItems } from '@/mocks/homeMangaData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">分类索引</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">按类型和主题快速浏览，精准找到你想看的漫画大全</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item, i) => (
            <div
              key={i}
              className="flex items-start gap-4 bg-background-50 rounded-xl p-5 group hover:bg-background-200/50 transition-colors cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center bg-accent-100 text-accent-600 rounded-xl text-xl flex-shrink-0">
                <i className={item.icon}></i>
              </div>
              <div className="min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 whitespace-nowrap">{item.title}</h3>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap">
                    {item.count}部
                  </span>
                </div>
                <p className="text-xs text-foreground-500 leading-snug">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}